/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.userBusinessFrequentBuyerPrograms.internal

import features.userBusinessFrequentBuyerPrograms.models.FrequentBuyerProgramsModel
import kangaroorewards.appsdk.core.io.IOResult
import kangaroorewards.appsdk.core.network.NetworkRequest
import kangaroorewards.appsdk.core.network.base.PathParameter
import kangaroorewards.appsdk.core.network.base.replaceInPath

internal class UserBusinessFrequentBuyerProgramsRequest : NetworkRequest() {

    suspend fun getUserBusinessFrequentBuyerPrograms(
        overrideHeaders: Map<String, String>? = null,
        businessId: String
    ): IOResult<FrequentBuyerProgramsModel> {
        return safeNetworkCall {
            get(
                endpoint = UserBusinessFrequentBuyerProgramsEndpoint.replaceInPath(
                    PathParameter("businessId", businessId),
                ),
                serverHostId = 0,
                overrideHeaders = overrideHeaders
            )
        }
    }
}
